import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=1d8e3b7a&scoped=true&"
import script from "./ModalView.vue?vue&type=script&lang=js&"
export * from "./ModalView.vue?vue&type=script&lang=js&"
import style0 from "./ModalView.vue?vue&type=style&index=0&id=1d8e3b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8e3b7a",
  null
  
)

export default component.exports